import { render, staticRenderFns } from "./SeatGroupForm.vue?vue&type=template&id=142507a4&scoped=true&"
import script from "./SeatGroupForm.vue?vue&type=script&lang=js&"
export * from "./SeatGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./SeatGroupForm.vue?vue&type=style&index=0&id=142507a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142507a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142507a4')) {
      api.createRecord('142507a4', component.options)
    } else {
      api.reload('142507a4', component.options)
    }
    module.hot.accept("./SeatGroupForm.vue?vue&type=template&id=142507a4&scoped=true&", function () {
      api.rerender('142507a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/SeatGroupForm.vue"
export default component.exports